export default {
  notPossible: 'Manual movements are not possible',
  executedConfirm: 'Is movement from "{source}" to "{target}" executed?',
  command: {
    accept: 'Accept command',
    ack: 'Acknowledge',
  },
};
